import { createBrowserAuth } from "@bindery/auth-consumer/browser";
import { ConvexReactClient } from "convex/react";
import * as z from "zod";

const convexUrl = z.url().parse(import.meta.env.VITE_CONVEX_URL);

export const convex = new ConvexReactClient(convexUrl);
convex.setAuth(createBrowserAuth().fetchToken);
